import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as InformationAction from 'store/actions/information';
import * as CurrencyAction from 'store/actions/currency';
import * as CollectionAction from 'store/actions/collection';
import { Button } from 'reactstrap';
import List from './list';
import FilterBox from './filter';
import AddDialog from './addDialog';
import ChooseVoucherTypeDialog from './chooseVoucherTypeDialog';
import { useHistory } from 'react-router';
import { getHeaders } from './headers';
import queryString from 'query-string';
import { t } from 'i18next';
import { getAllForFinance, exportFinanceData } from 'services/commercialInvoiceFinance';
import * as commercialInvoiceTransaction from 'services/commercialInvoiceTransaction';
import { NotificationManager } from 'react-notifications';
import DetailDialog from 'pages/invoice/CommercialInvoice/detailDialog';
import useActionPermission from 'hooks/useActionPermission';

function CommercialInvoiceReceivable() {
  const [searchValue, setSearchValue] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState(null);
  const [showDetail, setShowDetail] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [voucherSelect, setVoucherSelect] = React.useState(false);
  const { canPay } = useActionPermission('import_license');

  const actionLoading = useSelector((state) => state.loading.actionLoading);
  const dispatch = useDispatch();
  const router = useHistory();

  const [data, setData] = React.useState({ docs: [], totalDocs: 0 });

  React.useEffect(() => {
    dispatch(InformationAction.getBranch());
    dispatch(CollectionAction.getAll({}));
    dispatch(CurrencyAction.getAll({}));
  }, [dispatch, InformationAction.getBranch, CollectionAction.getAll, CurrencyAction.getAll]);

  React.useEffect(() => {
    loadData();
  }, [router.location.search]);

  const loadData = async (value = null) => {
    setSearchValue(value);
    let query = { limit: 10, page: 1 };
    if (router.location.search) query = queryString.parse(router.location.search);

    if (value) {
      query = { limit: 10, page: 1 };
    }

    const response = await getAllForFinance(query, value ? value : searchValue ? searchValue : {});
    if (response) {
      setData(response);
    }
  };

  const handleExport = async () => {
    const response = await exportFinanceData(searchValue ? searchValue : {});
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `commercial_invoice_finance_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };

  return (
    <>
      <List
        headers={getHeaders()}
        data={data}
        canPay={canPay}
        title={t('sidebar.license_custom_commercial_invoice_receivable')}
        filter={
          <FilterBox
            onSearch={(value) => {
              setSelectedData([]);
              loadData(value);
            }}
          />
        }
        onInvoiceClick={(invoice) => {
          setSelectedData(invoice);
          setShowDetail(true);
        }}
        onPay={(invoice) => {
          setSelectedData(invoice);
          setModalOpen(true);
        }}
        onPrint={(invoice) => {
          setSelectedData(invoice);
          setVoucherSelect(true);
        }}
        buttons={
          <>
            <Button
              style={{ width: 100 }}
              size='sm'
              disabled={actionLoading}
              onClick={handleExport}
            >
              {actionLoading ? <i className='fa fa-spinner mr-2' /> : <i className='fa fa-file-excel mr-2' />}
              {t('export')}
            </Button>
            <Button
              style={{ width: 100 }}
              size='sm'
              onClick={() => {
                window.location.reload();
              }}
            >
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={t('finance.sale_invoice')}
        data={selectedData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={async (values) => {
          try {
            values.invoice_id = selectedData._id;
            const res = await commercialInvoiceTransaction.makePurchase(values);
            if (res) {
              NotificationManager.success(t('operation_success'));
              setModalOpen(false);
              setSelectedData(null);
              loadData({});
            }
          } catch (e) {
            NotificationManager.error(e?.response?.data?.message || t('something_went_wrong'));
          }
        }}
      />
      {selectedData && (
        <ChooseVoucherTypeDialog
          modalOpen={voucherSelect}
          onToggle={() => setVoucherSelect(false)}
          selectedData={selectedData}
        />
      )}
      <DetailDialog
        data={selectedData}
        modalOpen={showDetail}
        onToggle={() => setShowDetail(false)}
      />
    </>
  );
}

export default CommercialInvoiceReceivable;
